<template>
    <div class="myAssets">
        
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    beforeRouteEnter (to, from, next) {
        window.location.href="https://arkwechat.niohome.com/asset-list.html"
    },
    mounted () {
        
    }
}
</script>


// WEBPACK FOOTER //
// src/views/myAssets.vue